import { useNavigate } from "react-router-dom";
import "./Register.css";

function Register() {

  const navigate = useNavigate();

  return (

    <div className="register-page">

      <div className="register-card">

        <div className="register-header">

          <div className="register-logo">

            🍽

          </div>

          <h1>HomeFoods</h1>

          <p>

            Join the HomeFoods Family

          </p>

        </div>

        <button

          className="customer-btn"

          onClick={() => navigate("/register/customer")}

        >

          🛒 Register as Customer

        </button>

        <button

          className="provider-btn"

          onClick={() => navigate("/register/provider")}

        >

          👨‍🍳 Become a Provider

        </button>

        <button

          className="delivery-btn"

          onClick={() => navigate("/register/delivery")}

        >

          🚴 Become Delivery Partner

        </button>

        <div className="login-link">

          Already have an account?

          <span onClick={() => navigate("/login")}>

            {" "}Login

          </span>

        </div>

      </div>

    </div>

  );

}

export default Register;